import React from 'react';
import SubPageTemplate from '../components/SubPageTemplate';

const SolutionC = () => {
  const features = [
    { title: 'Automated Bookkeeping', description: 'AI-powered financial tracking' },
    { title: 'Smart Forecasting', description: 'Predictive financial insights' },
    { title: 'Expense Management', description: 'Streamlined approvals and tracking' },
    { title: 'Compliance Monitoring', description: 'Stay audit-ready' },
    { title: 'Real-time Reporting', description: 'Financial data at your fingertips' },
    { title: 'Fraud Detection', description: 'AI-powered security' },
  ];

  return (
    <SubPageTemplate
      title="Finance"
      description="Smart financial operations powered by elegant intelligence."
      features={features}
    />
  );
};

export default SolutionC;
